import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  .app-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    max-width: 1200px;
    margin: 0 auto;
    padding: var(--spacing-md);
  }

  .main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: var(--spacing-lg) 0;
  }

  @media (max-width: 768px) {
    .app-container {
      padding: var(--spacing-sm);
    }
    
    .main-content {
      padding: var(--spacing-md) 0;
    }
  }

  /* Button styles */
  .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: var(--spacing-sm) var(--spacing-lg);
    border-radius: var(--border-radius-sm);
    font-weight: 500;
    transition: var(--transition-default);
    cursor: pointer;
  }

  .btn-primary {
    background-color: var(--color-primary);
    color: white;
  }

  .btn-primary:hover {
    background-color: var(--color-primary-light);
  }

  .btn-primary:active {
    background-color: var(--color-primary-dark);
  }

  .btn-secondary {
    background-color: transparent;
    color: var(--color-primary);
    border: 1px solid var(--color-primary);
  }

  .btn-secondary:hover {
    background-color: rgba(0, 113, 227, 0.05);
  }

  /* Utility classes */
  .text-center {
    text-align: center;
  }

  .mb-sm {
    margin-bottom: var(--spacing-sm);
  }

  .mb-md {
    margin-bottom: var(--spacing-md);
  }

  .mb-lg {
    margin-bottom: var(--spacing-lg);
  }

  .mt-sm {
    margin-top: var(--spacing-sm);
  }

  .mt-md {
    margin-top: var(--spacing-md);
  }

  .mt-lg {
    margin-top: var(--spacing-lg);
  }
`;